module.exports = __webpack_public_path__ + "img/gxhsjyy.2030b3ea.png";